import { Flex, Tag } from 'antd';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const EmployeeSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeEmployees } = useNewClientsListContext();

  const { employees } = filtersMap.get(id)!;

  if (employees.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      <Tag
        className={`${PF}__tag`}
        closable
        onClose={() => {
          onChangeEmployees([], id);
        }}
      >
        Выбрано: {employees.length} сотрудник
        {employees.length === 1 ? '' : employees.length > 4 ? 'ов' : 'а'}
      </Tag>
    </Flex>
  );
};
